import vertexShader from "./dissolve.vert";
import fragmentShader from "./dissolve.frag";

const DissolveShader = {
  uniforms: {
    tDiffuse: { value: null },
    opacity: { value: 1.0 },
    uProgress: { value: 0 },
  },
  vertexShader,
  fragmentShader,
};

export default DissolveShader;
